import { Component, Input,  } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/services/alert.service';
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'app-feature-requiring-new-firmware-modal',
  templateUrl: './feature-requiring-new-firmware-modal.component.html',
  styleUrls: ['./feature-requiring-new-firmware-modal.component.scss']
})
export class FeatureRequiringNewFirmwareModalComponent {

  @Input() deviceId!: string;
  @Input() featureName: string = "";
  @Input() featureDescription: string = "";
  loading = false;

  constructor(
    protected dialogRef: NbDialogRef<FeatureRequiringNewFirmwareModalComponent>,
    private api: ApiService,
    private alertService: AlertService,
    private translate: TranslateService
  ) { }

  cancel(): void {
    this.dialogRef.close();
  }

  updateDevice() {
    this.loading = true;

    this.api.postStartUpdatingDevice(this.deviceId)
      .subscribe({
        next: () => {
          this.loading = false;
          this.alertService.success("alerts.request-device-update-success", 5000);
          this.dialogRef.close();
        },
        error: err => {
          this.loading = false;
          this.dialogRef.close();
        }
      });
  }

  featureNameTranslated() {
    return this.translate.instant(this.featureName);
  }
}
